import { ExternalLink } from '~/components/ExternalLink'
import { CookieTableBodyType } from '~/static-pages/Cookies/types/Cookies.types'

export const CookieTableBody = ({
  name,
  issuedBy,
  purpose,
  optional,
  storageTime,
  receiver,
}: CookieTableBodyType): React.ReactElement => {
  const tdClassSmall = 'text-xxs h-10 py-3 sm:p-3'
  const tdClassLarge = 'text-xxs h-20 sm:h-16 md:h-14 py-3 sm:p-3'
  return (
    <tbody className="flex-1">
      <tr className="flex flex-col flex-no wrap mb-2 sm:mb-0">
        <td className={tdClassSmall}>{name}</td>
        <td className={tdClassSmall}>{issuedBy}</td>
        <td className={tdClassLarge}>{purpose}</td>
        <td className={tdClassSmall}>{optional}</td>
        <td className={tdClassSmall}>{receiver}</td>
        <td className={tdClassLarge}>
          {storageTime}
          {name === 'Google Analytics' && (
            <ExternalLink href="https://policies.google.com/privacy?hl=no">
              Googles retningslinjer for personvern.
            </ExternalLink>
          )}
        </td>
      </tr>
    </tbody>
  )
}
